export const artsCultureQuestions = [
  {
    id: 'arts-001',
    category: 'Arts & Culture',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Who painted the Mona Lisa?',
    options: ['Leonardo da Vinci', 'Vincent van Gogh', 'Pablo Picasso', 'Claude Monet'],
    answer: 'Leonardo da Vinci',
    insight: 'The Mona Lisa is displayed in the Louvre Museum.',
    tags: ['painting', 'mona lisa', 'renaissance'],
    points: 10,
  },
  {
    id: 'arts-002',
    category: 'Arts & Culture',
    difficulty: 'Easy',
    type: 'multiple',
    question: "Who wrote 'Romeo and Juliet'?",
    options: ['William Shakespeare', 'Charles Dickens', 'Jane Austen', 'Mark Twain'],
    answer: 'William Shakespeare',
    insight: 'Shakespeare wrote the tragedy in the late 1500s.',
    tags: ['literature', 'shakespeare', 'plays'],
    points: 10,
  },
  {
    id: 'arts-003',
    category: 'Arts & Culture',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'Ballet has roots in European court culture.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Ballet developed from court dances in Renaissance Europe.',
    tags: ['dance', 'ballet', 'culture'],
    points: 10,
  },
  {
    id: 'arts-004',
    category: 'Arts & Culture',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which artist painted The Starry Night?',
    options: ['Vincent van Gogh', 'Pablo Picasso', 'Frida Kahlo', 'Salvador Dali'],
    answer: 'Vincent van Gogh',
    insight: 'Van Gogh painted The Starry Night in 1889.',
    tags: ['painting', 'van gogh', 'art history'],
    points: 20,
  },
  {
    id: 'arts-005',
    category: 'Arts & Culture',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which instrument has keys, pedals, and strings?',
    options: ['Piano', 'Flute', 'Trumpet', 'Drum'],
    answer: 'Piano',
    insight: 'A piano uses hammers to strike strings when keys are pressed.',
    tags: ['music', 'instruments', 'piano'],
    points: 20,
  },
  {
    id: 'arts-006',
    category: 'Arts & Culture',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'Haiku poetry traditionally has three lines.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Traditional haiku often use a 5-7-5 sound pattern.',
    tags: ['poetry', 'haiku', 'japan'],
    points: 20,
  },
  {
    id: 'arts-007',
    category: 'Arts & Culture',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which museum is home to the Mona Lisa?',
    options: ['The Louvre', 'The Prado', 'The Uffizi', 'The Met'],
    answer: 'The Louvre',
    insight: 'The Louvre in Paris houses the Mona Lisa.',
    tags: ['museums', 'louvre', 'paris'],
    points: 20,
  },
  {
    id: 'arts-008',
    category: 'Arts & Culture',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which art movement is associated with Monet and Renoir?',
    options: ['Impressionism', 'Cubism', 'Surrealism', 'Baroque'],
    answer: 'Impressionism',
    insight: 'Impressionists focused on light, color, and everyday scenes.',
    tags: ['impressionism', 'monet', 'art movements'],
    points: 30,
  },
  {
    id: 'arts-009',
    category: 'Arts & Culture',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which author wrote Pride and Prejudice?',
    options: ['Jane Austen', 'Mary Shelley', 'Emily Bronte', 'Virginia Woolf'],
    answer: 'Jane Austen',
    insight: 'Jane Austen published the novel in 1813.',
    tags: ['literature', 'jane austen', 'novels'],
    points: 30,
  },
  {
    id: 'arts-010',
    category: 'Arts & Culture',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'The color wheel is often used to explain relationships between colors.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Color wheels help show complementary and related colors.',
    tags: ['color', 'design', 'visual art'],
    points: 30,
  },
];
